import { render, staticRenderFns } from "./DebtorsPaymentTemplate.vue?vue&type=template&id=c09937bc"
import script from "./DebtorsPaymentTemplate.vue?vue&type=script&lang=js"
export * from "./DebtorsPaymentTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports